// extracted by mini-css-extract-plugin
export default {"container":"daN8ULjvkWHDukWwYqwO"};